import { render, staticRenderFns } from "./input-file.vue?vue&type=template&id=1a6370f7&scoped=true&lang=pug&"
import script from "./input-file.vue?vue&type=script&lang=ts&"
export * from "./input-file.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6370f7",
  null
  
)

export default component.exports